// @ts-nocheck
/* eslint-disable */
import React from 'react';
import { Button } from '@arco-design/web-react';
import { useNavigate } from 'react-router-dom';
import './index.scss';

function Error() {
  const navigate = useNavigate();

  const handleRetry = () => {
    // 清除token，重新登录
    localStorage.removeItem('authToken');
    navigate('/login', { replace: true });
    window.location.reload();
  };

  return (
    <div className="error">
      <div className="error-content">
        <h1 className="error-title">系统错误</h1>
        <h3 className="error-subtitle">菜单数据获取失败，请联系管理员添加菜单权限</h3>
        <Button type="primary" onClick={handleRetry} style={{ marginTop: '24px' }}>
          返回登录
        </Button>
      </div>
    </div>
  );
}

export default Error;

